import React, {useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Table, Input, Form, FormGroup, FormText, Modal, ModalBody,ModalFooter } from 'reactstrap';
import moment from 'moment';
import { tailChase } from 'ldrs'
import { useDispatch, useSelector } from 'react-redux';

tailChase.register()

const Exclusion = (props) => {

    const [table, setTable] = useState([",","."]);
    const [formEventID, setFormEventID] = useState("");
    const [formSubtype, setFormSubtype] = useState("");
    const [formSection, setFormSection] = useState("");
    const [eventList, setEventList] = useState([",", "."]);
    const [subtypeList, setSubtypeList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [inputError, setInputError] = useState(false);
    const [deleteAllModal, setDeleteAllModal] = useState(false);
    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);
    //const [forceRerender, setForceRerender] = useState(0); //This is probably not the way to do what I want to do. Too bad.

    const firstUpdate = useRef(false);

    useEffect(() => {
        getData();
        getEventList();
    }, [])

    function getData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                semester: props.activeTerm
            }
        fetch('GetExcludeList', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function getEventList() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                semester: props.activeTerm
            }
        fetch('GetEventExclude', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
            .then((responseJSON) => { setEventList(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    useEffect(() => {
        if (firstUpdate.current) {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + reduxData.apiKey
            dispatch({ type: 'foundation/setFetchTime' })
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                eventid: formEventID
            }
            fetch('GetExcludeSubtypes', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
                .then((responseJSON) => { setSubtypeList(responseJSON) })
            localStorage.setItem("lastFetch", moment());
        } else firstUpdate.current = true;
    }, [formEventID])

    useEffect(() => {
        if (formEventID != "") {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + reduxData.apiKey
            dispatch({ type: 'foundation/setFetchTime' })
            let toSend = {
                userLevel: reduxData.userInfo.level.pk,
                eventid: formEventID,
                subtype: formSubtype
            }
            fetch('GetExcludeSections', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
                .then((response) => response.json())
                .then((responseJSON) => { setSectionList(responseJSON) })
            localStorage.setItem("lastFetch", moment());
        }
    }, [formSubtype])

    function addNew  (e)  {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        if (formEventID == "" || formSubtype == "" || formSection == "") {
            setInputError(true);
            return;
        }
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            eventid: formEventID,
            subtype: formSubtype,
            section: formSection,
            semester: props.activeTerm
        }
        //console.log("add: " + JSON.stringify(toSend));
        fetch('AddExcludedEvent', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        localStorage.setItem("lastFetch", moment());
    }

    function deleteFrom(pk) {
        //console.log("deleting: " + pk);
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            targetpk: pk,
            semester: props.activeTerm
        }
        fetch('DeleteExclusion', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        localStorage.setItem("lastFetch", moment());
    }

    function deleteAll() {
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = { 
            userLevel: reduxData.userInfo.level.pk,
            excludeData: table,
            semester: props.activeTerm
        }
        fetch('DeleteAllExclusions', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON); setDeleteAllModal(!deleteAllModal) })
    }
    
        return (
            <div>
                <Modal isOpen={deleteAllModal} toggle={() => setDeleteAllModal(!deleteAllModal)}>
                    <ModalBody>Remove all exclusions? You will need to add them back.</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => deleteAll()}>Do it</Button>
                        <Button onClick={() => setDeleteAllModal(!deleteAllModal)}>Nevermind</Button>
                    </ModalFooter>
                </Modal>
                <div className="halfOfParent" style={{ visibility: !props.editLock ? 'visible' : 'hidden' }}>
                    <Form inline className="d-flex" onSubmit={e => addNew(e)} >
                        <FormGroup>
                    <Input type="select" name="eventid" id="eventid" value={formEventID} onChange={e => setFormEventID(e.target.value)} >
                        <option disabled value="">Event ID</option>
                            {eventList.map(event => (
                                <option value={event.eventid}>{event.eventid}</option>
                                )) }
                            </Input>
                            <FormText hidden={!inputError}>Please select from each option before submitting</FormText>
                            </FormGroup>
                        &nbsp;
                        <FormGroup>
                    <Input type="select" name="subtype" id="subtype" value={formSubtype} onChange={e => setFormSubtype(e.target.value)}>
                            <option disabled value="">Subtype</option>
                            {subtypeList.map(type => (
                                <option value={type.subtype}>{type.subtype}</option>
                                ))}
                            </Input>
                            </FormGroup>
                        &nbsp;
                        <FormGroup>
                    <Input type="select" name="section" id="section" value={formSection} onChange={e => setFormSection(e.target.value)}>
                        <option disabled value="">Section</option>
                            {sectionList.map(item => (
                                <option value={item.section}>{item.section}</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Button type="submit" outline color="success" invalid={true}>Go</Button>
                        </FormGroup>
                        <br />
                            {/*<div className="redneckFeedback" hidden={!inputError}>Please select from each option before submitting</div>*/}
                        
                    </Form>
                    </div>
                <br />
                <div className="rightAlignCustom"><Button color="danger" onClick={() => setDeleteAllModal(!deleteAllModal)}>Delete All</Button></div>
                {table.length == 0 ? <l-tail-chase color="#86d3ff" size="50" speed="1.4"/> : < Table striped>
                    <thead>
                        <th>Section ID</th>
                        <th>Event Information</th>
                        <th>Event Full Name</th>
                        <th>Last Changed By</th>
                        <th></th>
                    </thead>
                    <tbody>
                        {table.map(item => (
                            <tr>
                                <td>{item.sectionid}</td>
                                <td>{item.eventinfo}</td>
                                <td>{item.longname}</td>
                                <td>{item.changedby}</td>
                                <td><Button style={{ visibility: !props.editLock ? 'visible' : 'hidden' }} outline color="danger" onClick={() => deleteFrom(item.pk)}>Delete</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>}
            </div>
        );
}



export default Exclusion;